var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#E9F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8133 29.6067L39.0133 38.8733C41.72 41.3267 41.3333 45.8333 36.32 45.8333H27.68C22.6666 45.8333 22.28 41.3267 24.9866 38.8733L39.0133 26.1267C41.72 23.6733 41.3333 19.1667 36.32 19.1667H27.68C22.6666 19.1667 22.28 23.6733 24.9866 26.1267",
    stroke: "#1A6D73",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingInvitation);
export default __webpack_public_path__ + "static/media/pendingInvitation.99bbf9516a89e39c34745165dd5ca8a8.svg";
export { ForwardRef as ReactComponent };